// extracted by mini-css-extract-plugin
export default {"container":"Malfunctions_container__2LSn-","spinner":"Malfunctions_spinner__jf-LE"};